import { useQueryString } from "../../hooks/useQueryString";
import { Adyen } from "./Adyen";

function PaymentComponent() {
  const { accountHolder, role, lang, shopReference, amount, shopperEmail } =
    useQueryString();
  const localStorageEntries = [
    { key: "accountHolderId", value: accountHolder },
    { key: "role", value: role },
    { key: "lang", value: lang },
    { key: "shopReference", value: shopReference },
    { key: "amount", value: amount },
    { key: "shopperEmail", value: shopperEmail },
  ];

  localStorageEntries.forEach(({ key, value }) => {
    if (value !== undefined) {
      localStorage.setItem(key, value);
    }
  });
  return (
    <div id="modal-overlay" className="modal-overlay">
      <div className="modal-content_adyen">
        <Adyen />
      </div>
    </div>
  );
}

export default PaymentComponent;
